import { useNavigate } from 'react-router-dom';
import { BuilderWizard, WizardStep } from '@unwritten/builder';
import { Package } from 'lucide-react';

export function PackWizard() {
  const navigate = useNavigate();

  const steps: WizardStep[] = [
    {
      id: 'basics',
      title: 'Basic Info',
      description: 'Set up pack name and type',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Basic pack information form coming soon...</p>
        </div>
      ),
    },
    {
      id: 'content',
      title: 'Pack Content',
      description: 'Add items to the pack',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Pack content editor coming soon...</p>
        </div>
      ),
    },
    {
      id: 'settings',
      title: 'Settings',
      description: 'Configure pack settings',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Pack settings form coming soon...</p>
        </div>
      ),
    },
    {
      id: 'review',
      title: 'Review',
      description: 'Review and create pack',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Review screen coming soon...</p>
        </div>
      ),
    },
  ];

  const handleComplete = async (data: any) => {
    console.log('Pack created:', data);
    navigate('/packs');
  };

  const handleCancel = () => {
    navigate('/packs');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex items-center gap-3 mb-6">
        <Package className="w-8 h-8 text-blue-600" />
        <h1 className="text-3xl font-bold">Create New Pack</h1>
      </div>

      <BuilderWizard
        steps={steps}
        onComplete={handleComplete}
        onCancel={handleCancel}
        persistenceKey="pack-wizard"
      />
    </div>
  );
}
